(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-header"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('studio-shop-header'))customElements.define('studio-shop-header',class extends HTMLElement{
connectedCallback(){this.controller=new AbortController();const signal=this.controller.signal;
// Delegate from the stable header so app/section updates cannot detach cart handlers.
this.addEventListener('click',event=>{
 if(!(event.target instanceof Element)||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
 const link=event.target.closest('[data-studio-cart]');
 if(!link||!this.contains(link))return;
 const drawer=document.getElementById('cart-drawer');
 if(typeof drawer?.open!=='function')return;
 event.preventDefault();event.stopPropagation();
 this.classList.remove('cs-mobile-search-open');
 this.querySelector('[data-mobile-search]')?.setAttribute('aria-expanded','false');
 this.querySelector('.cs-mobile-menu[open]')?.close();
 drawer.open();
},{signal,capture:true});

const mobile=this.mobile=matchMedia('(max-width:749px)');
const dialog=this.querySelector('.cs-mobile-menu');
const menuButton=this.querySelector('[data-mobile-menu]');
const searchButton=this.querySelector('[data-mobile-search]');
const nativeSearch=this.querySelector('clendo-native-search');
const closeSearch=()=>nativeSearch?.closeMobile();
menuButton.addEventListener('click',()=>{closeSearch();dialog.showModal();menuButton.setAttribute('aria-expanded','true')},{signal});
this.querySelector('[data-mobile-menu-close]').addEventListener('click',()=>dialog.close(),{signal});
dialog.addEventListener('close',()=>{menuButton.setAttribute('aria-expanded','false');if(mobile.matches)menuButton.focus()},{signal});
dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close()}},{signal});
searchButton.addEventListener('click',event=>{if(!mobile.matches||!nativeSearch?.openMobile)return;event.preventDefault();nativeSearch.openMobile(searchButton)},{signal});
this.querySelector('[data-mobile-search-close]').addEventListener('click',()=>closeSearch(true),{signal});
this.addEventListener('keydown',event=>{if(event.key==='Escape'&&this.classList.contains('cs-mobile-search-open'))closeSearch(true)},{signal});
mobile.addEventListener('change',()=>{if(!mobile.matches){if(dialog.open)dialog.close();closeSearch()}},{signal});
document.addEventListener('click',event=>{if(!this.contains(event.target))this.querySelectorAll('details[open]').forEach(d=>d.open=false)},{signal});this.addEventListener('keydown',event=>{if(event.key==='Escape'){const switcher=event.target.closest('.cs-shop-switch[open]');if(switcher){event.preventDefault();event.stopPropagation();switcher.open=false;switcher.querySelector('summary').focus();return}const menu=this.querySelector('.cs-mega');if(menu.open){menu.open=false;menu.querySelector('summary').focus()}}},{signal});document.addEventListener('shopify:cart:lines-update',event=>{event.promise?.then(({cart,detail})=>{const count=cart?.totalQuantity??detail?.itemCount;if(typeof count==='number'&&this.isConnected)this.querySelectorAll('[data-studio-count]').forEach(badge=>badge.textContent=count)}).catch(()=>{})},{signal})}
disconnectedCallback(){this.controller?.abort();}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-system"]) return;
  try {
    
{
 const dictionary=JSON.parse(document.getElementById('StudioTranslationLabels')?.textContent || '{}');
 const selector='.oh-card-categories__media img[loading="lazy"]';
 const navSelector='button[aria-label="Slide next"],button[aria-label="Slide back"]';
 const enhance=root=>{
  for(const button of [...(root.matches?.(navSelector)?[root]:[]),...root.querySelectorAll(navSelector)]){
   if(button.closest('.shopify-section')?.querySelector('.oh-card-categories'))button.setAttribute('aria-label',button.getAttribute('aria-label')==='Slide next'?dictionary.next_categories:dictionary.previous_categories);
  }
  const images=[...(root.matches?.(selector)?[root]:[]),...root.querySelectorAll(selector)];
  for(const img of images)if(img.sizes.includes('normalpx'))img.sizes='auto, (min-width: 1000px) 220px, calc((100vw - 48px) / 2)';
 };
 enhance(document);
 const roots=new Set();
 let frame=0;
 new MutationObserver(records=>{
  for(const record of records)for(const node of record.addedNodes){
   if(!(node instanceof Element))continue;
   roots.add(node);
  }
  if(!roots.size||frame)return;
  frame=requestAnimationFrame(()=>{
   frame=0;
   for(const root of roots){
    if(!root.isConnected)continue;
    let ancestor=root.parentElement;
    while(ancestor&&!roots.has(ancestor))ancestor=ancestor.parentElement;
    if(!ancestor)enhance(root);
   }
   roots.clear();
  });
 }).observe(document.body,{childList:true,subtree:true});
}

if (document.querySelector('.product-information')) {
 const appLabels = JSON.parse(document.getElementById('StudioUpsellLabels')?.textContent || '{}');
 const exactLabels = new Map(Object.entries(appLabels));
 const enhanceUpsell = root => {
  const texts = document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
  for (let node = texts.nextNode();node;node = texts.nextNode()) {
   if (!node.parentElement?.closest('lb-upsell-widget') || node.parentElement.closest('script,style')) continue;
   const value = exactLabels.get(node.textContent.trim());
   if (value && node.textContent.trim() !== value) node.textContent = node.textContent.replace(node.textContent.trim(),value);
  }
  for (const element of root.querySelectorAll('[aria-label]')) {
   const value = exactLabels.get(element.getAttribute('aria-label'));
   if (value) element.setAttribute('aria-label',value);
  }
  const within = selector => [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
  for (const img of within('lb-upsell-widget img.lb-card-img')) {
   const source = img.getAttribute('src') || '';
   if (!/_400x400\.(?:webp|jpe?g|png)(?:\?|$)/i.test(source)) continue;
   const url = new URL(source, document.baseURI);
   if (url.hostname !== 'cdn.shopify.com' && url.hostname !== location.hostname) continue;
   if (!img.hasAttribute('width')) img.setAttribute('width', '400');
   if (!img.hasAttribute('height')) img.setAttribute('height', '400');
   img.decoding = 'async';
   const flat = !!img.closest('.lb-flat-card');
   const sizes = flat ? '60px' : 'auto, (min-width: 1000px) 280px, (min-width: 750px) 240px, 180px';
   if (!img.closest('.product-details')) img.loading = 'lazy';
   if (img.sizes !== sizes) img.sizes = sizes;
   const widths = flat ? [120,240,400] : [160,240,400];
   const srcset = widths.map(width => source.replace('_400x400.', `_${width}x${width}.`) + ` ${width}w`).join(', ');
   if (img.srcset !== srcset) img.srcset = srcset;
  }
  for (const list of within('lb-upsell-widget .lb-bundle-products, lb-upsell-widget .lb-bundle-offers, lb-upsell-widget .lb-bundle-tgrid-trigger')) {
   const role = list.querySelector(':scope > [role="listitem"]') ? 'list' : 'group';
   if (list.getAttribute('role') !== role) list.setAttribute('role', role);
  }
 };
 const pendingWidgets = new Set();
 const imageObservers = new Map();
 const discoveryRoots = new Set();
 let frame = 0;
 const register = widget => {
  if (imageObservers.has(widget)) return;
  const observer = new MutationObserver(() => {
   pendingWidgets.add(widget);
   queue();
  });
  observer.observe(widget, {attributes:true,subtree:true,attributeFilter:['src']});
  imageObservers.set(widget, observer);
  pendingWidgets.add(widget);
 };
 const discover = root => {
  if (root.matches?.('lb-upsell-widget')) register(root);
  for (const widget of root.querySelectorAll('lb-upsell-widget')) register(widget);
 };
 const queue = () => {
  if (frame) return;
  frame = requestAnimationFrame(() => {
   frame = 0;
   for (const root of discoveryRoots) {
    if (!root.isConnected) continue;
    let ancestor = root.parentElement;
    while (ancestor && !discoveryRoots.has(ancestor)) ancestor = ancestor.parentElement;
    if (!ancestor) discover(root);
   }
   discoveryRoots.clear();
   for (const [widget, observer] of imageObservers) {
    if (widget.isConnected) continue;
    observer.disconnect();
    imageObservers.delete(widget);
    pendingWidgets.delete(widget);
   }
   for (const widget of pendingWidgets) if (widget.isConnected) enhanceUpsell(widget);
   pendingWidgets.clear();
  });
 };
 discover(document);
 for (const widget of pendingWidgets) enhanceUpsell(widget);
 pendingWidgets.clear();
 new MutationObserver(records => {
  for (const record of records) {
   const widget = record.target instanceof Element && record.target.closest('lb-upsell-widget');
   if (widget) pendingWidgets.add(widget);
   else for (const node of record.addedNodes) if (node instanceof Element) discoveryRoots.add(node);
  }
  if (pendingWidgets.size || discoveryRoots.size || [...imageObservers.keys()].some(widget => !widget.isConnected)) queue();
 }).observe(document.body, {childList:true,subtree:true});
}

  } catch(e) { console.error(e); }
})();
})();
